// src/App.js

import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";

import Home from "./pages/Home";

import Signup from "./pages/Signup";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import ForgotPassword from "./pages/ForgotPassword";

import CreatorDashboard from "./pages/CreatorDashboard";
import AdminCreatorInput from "./pages/AdminCreatorInput";

import IntelDashboard from "./pages/IntelDashboard";
import Playground from "./pages/Playground";










function App() {
  return (
    <BrowserRouter>
      <Navbar />

      <Routes>
        {/* 🔥 CORE */}
        <Route path="/" element={<Home />} />
        <Route path="/dashboard" element={<CreatorDashboard />} />

        {/* AUTH */}
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* INTEL DASHBOARD */}
        <Route path="/admin/creator-input" element={<AdminCreatorInput />} />
        <Route path="/intel" element={<IntelDashboard />} />
        <Route path="/playground" element={<Playground />} />

      </Routes>


    </BrowserRouter>
  );
}

export default App;